import script from "./CatalogSectionMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./CatalogSectionMenu.vue?vue&type=script&lang=ts&setup=true"

import "./CatalogSectionMenu.vue?vue&type=style&index=0&id=a9d0b2d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9d0b2d6"]])

export default __exports__